/**
 * parseAsync
 *
 * @desc 描述：解析 Promise
 */

/* =================================================== */

/**
 * 解析 Promise
 * @desc 便于 async/await 结构接参，错误处理
 */
export const parseAsync = <Res = unknown, Err = Error>(promise: Promise<Res>) =>
  Promise.resolve(promise)
    .then((data) => [undefined, data] as [undefined, Res])
    .catch((err: Err) => [err, undefined] as [Err, undefined]);

/**
 * parseAsync 返回类型
 */
export type ParseAsync<Res = unknown, Err = Error> = Promise<[undefined, Res] | [Err, undefined]>;
